<template>
  <portal>
      <div class="mb-8 d-flex align-center">
          <v-icon color="primary" size="30">mdi-bank</v-icon>
          <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Accounts</h1>
      </div>
      <brokerage-accounts />
      <annuities />
      <template v-slot:disclosure>
          <v-col class="px-12 py-8" v-html="company.disclosure_client_portal"></v-col>
      </template>
  </portal>
</template>

<script>
import Portal from "@/components/Portal";
import BrokerageAccounts from "@/components/accounts/BrokerageAccounts";
import Annuities from "@/components/accounts/Annuities";
import {mapState} from "vuex";

export default {
    name: "Accounts",
    components: {
      BrokerageAccounts,
      Annuities,
      Portal,
    },
    computed: {
        ...mapState('company', [
            'company'
        ]),
    }
  }
</script>
